import { config } from 'api';

import { TAGS_HIERARCHY_PATH } from './constants';

export default [
  {
    path: 'navigation',
    indexRoute: {
      getComponent(location, callback) {
        import(/* webpackChunkName: "navigation" */ './containers/StartNavigationPage')
          .then(component => callback(null, component.default));
      },
    },
    layoutFooter: false,
    childRoutes: [
      {
        path: `browse${TAGS_HIERARCHY_PATH}`,
        getComponent(location, callback) {
          import(/* webpackChunkName: "navigation" */ './containers/GroceryCategoriesBrowseNavigationPage')
            .then(component => callback(null, component.default));
        },
      },
      {
        path: `${config.routes.navigation.highlighted}${TAGS_HIERARCHY_PATH}`,
        getComponent(location, callback) {
          import(/* webpackChunkName: "navigation" */ './containers/HighlightedCategoriesBrowseNavigationPage')
            .then(component => callback(null, component.default));
        },
      },
    ],
  },
];
